import React from 'react';
import { Link } from 'react-router';
import { useQuery } from '@apollo/client';

import GET_ORDER_HISTORY from '../../gql/order-history.gql';
import Loading from '../../components/loading/loading';
import useProperty from '../../hooks/use-property';

export const defaultStoreID = 10051;

export default function Home() {
  const [storeId] = useProperty('storeId', defaultStoreID);
  const { loading, error, data } = useQuery(GET_ORDER_HISTORY);

  if (loading) { return <Loading />; }

  // TODO
  if (error) { return <div data-testid="error-container"><Loading /></div>; }

  return (
    <h1>
      {data.orderHistory.orders.map((order) => (
        <div key={order.orderToken}>
          <Link to={`/store/${storeId}/exchange/${order.orderId}`}>
            <span>Order:</span>
            <span>{order.orderId}</span>
            <span>{order.statusDisplayText}</span>
          </Link>
        </div>
      ))}
    </h1>
  );
}
